import classNames from 'classnames/bind';

import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';

import { Card } from 'components/Card/Card';
import { Heading } from 'components/Heading/Heading';
import { MeterValue } from 'components/Meter';

import styles from '../OrganizationUtilization.module.scss';
import { useDeployments } from 'hooks/api/useDeployments';
import { DEPLOYMENT_ACTIVE_STATES } from 'types/deployment';

const c = classNames.bind(styles);

export function DeploymentsUtilizationCard() {
  const { data: currentPlan } = useCurrentPlan();
  const { data: active } = useDeployments({
    limit: 1,
    states: [...DEPLOYMENT_ACTIVE_STATES],
  });

  if (!currentPlan) {
    return null;
  }

  const activeCount = active ? active.total_elements : 0;
  const max = currentPlan.running_deployment_limit;

  return (
    <Card className={c('item')}>
      <Heading level="4" asChild>
        <h3>Running Deployments</h3>
      </Heading>

      <div className={c('meter-value')}>
        <MeterValue value={activeCount} max={max} />
      </div>
    </Card>
  );
}
